import React from "react";

import Heading from "./Heading";
import ContentSection from "./ContentSection";
import Footer from "./Footer";

import styled from "styled-components";

const Header = styled.div`
  font-size: 20px;
  font-weight: bold;
  margin-top: 20px;
`;

const SubHeader = styled.div`
  font-size: 18px;
  font-weight: bold;
  margin-top: 10px;
  color: #707070;
`;

const Content = styled.p``;

const TermsOfUse = (props) => {
  const style = {
    heading: { fontSize: 20, fontWeight: "bold", marginTop: 20 },
    subHeading: {
      fontSize: 18,
      fontWeight: "bold",
      marginTop: 10,
      color: "#707070",
    },
  };

  const { isModal } = props;

  return (
    <div>
      {!isModal && <Heading {...props} />}
      <ContentSection>
        <Header>
          Terms of Use and Agreement; Last updated December 14, 2020
        </Header>
        <Content>
          www.RoboPortfolioPerformanceAnalyzer.com or www.RoboPPA.com “Website”,
          providing “Analysis” of managed financial portfolios is subject to the
          following “Terms of Use” and “Agreement”. RoboPPA™ and RoboPortfolio
          Performance Analyzer™ are trademarks of the same “Website
          Application”, pending registration by Robert Korkie and Edward Elyn.
          All rights are reserved.
        </Content>
        <Content>
          The Website reserves the right, at its sole discretion, to change,
          modify, add or remove portions of these Terms of Use, at any time. It
          is your responsibility to check these Terms of Use for changes. Your
          continued use of RoboPPA™, following the posting of changes will mean
          that you accept and agree to the changes. Providing that you comply
          with these Terms of Use, RoboPPA™ grants you a personal,
          non-exclusive, non-transferable, limited privilege to enter and use
          the Website, subject to its Terms of Use.
        </Content>
        <Content>
          By registering an email address on the Website and entering data to
          obtain and use the Analysis, you acknowledge that you have read,
          understood, and agree to be legally bound by these Terms of Use.
        </Content>
        <Content>
          We reserve the right, in our sole discretion, to restrict, suspend, or
          terminate this Agreement and your access to all or any part of the
          Analysis, at any time and for any reason without prior notice or
          liability. this Agreement constitutes the entire Agreement between you
          and us with respect to the subject matter, and supersedes all previous
          or contemporaneous agreements, whether written or oral, between the
          parties with respect to the subject matter.
        </Content>
        <Header>User Inputs</Header>
        <Content>
          An important consideration in portfolio performance analyses is the
          accuracy of the input data. The input data includes portfolio market
          values, transfers, and management fees. RoboPPA™ implicitly assumes
          that the user entered inputs are without error, in calculating a
          portfolio’s historical performance and conclusions derived therefrom.
        </Content>
        <Content>
          Users of RoboPPA™ are entirely responsible for the accuracy of their
          data inputs. No refunds are provided for analysis based on incorrect
          data inputs.
        </Content>
        <Content>
          RoboPPA™ assumes that the portfolio’s owner values portfolio return
          and is averse to its risk. Management fees are useful only if the
          managed portfolio has sufficiently larger risk adjusted return than
          alternative benchmark portfolios. Other considerations are not part of
          the analysis.
        </Content>
        <Content>
          RoboPPA™ provides investment information regarding the after fees
          risk adjusted return of the managed portfolio relative to the
          benchmarks. Clients are responsible for their own investing goals and
          risk preferences and how they are affected by the performance analysis
          information.
        </Content>
        <Content>
          RoboPPA™ tracks the past performance of your managed portfolio in
          comparison with the past performance of your selected benchmarks. A
          small number of historical return samples provides less information
          than large samples and is less reliable.
        </Content>
        <Content>
          Portfolio returns may vary depending on the portfolio’s assets and the
          state of the financial markets and economy. Performance data and
          analysis are from the past and therefore are not necessarily
          indicative of future performance.
        </Content>
        <Content>
          The benchmark data set used in the RoboPPA™ is obtained from publicly
          available sources and RoboPPA™ does not guarantee its accuracy. The
          sources may include Investing.com, S&P Dow Jones Indices, Yahoo
          Finance, US Bureau of Labor Statistics, Federal Reserve Bank of St
          Louis, Bank of Canada Financial Market Statistics, Statistics Canada,
          and the CBOE.
        </Content>
        <Header>Registration and Personal Information</Header>
        <Content>
          Registered use is obtained by signing up with an email address and
          user specified password. A user email address and corresponding
          password can only be used by you, the “Registered User”. You are
          solely responsible for the confidentiality and use of your user email
          address and password, as well as for any use, misuse, or
          communications entered on the Website. You agree to notify us
          immediately if you become aware of any loss, theft or unauthorized use
          of your user ID or password, and we reserve the right to delete or
          change one or both of them at any time and for any reason.
        </Content>
        <Content>
          Any personal information, data, or Analyses will not be disclosed to
          third parties, unless the disclosure is claimed by legal bodies as a
          result of law infringement.
        </Content>
        <Header>Intellectual Property</Header>
        <Content>
          RoboPPA™, its Website, and its Analysis are protected by trademark and
          other proprietary rights of RoboPPA™. Thus, any Content and Analysis
          provided by RoboPPA™ is protected by Intellectual Property Laws,
          unless it has been authorized by RoboPPA™.
        </Content>
        <Content>
          Unless manifestly permitted by RoboPPA™ or Intellectual Property Laws,
          copying, storage, reuse, redistribution, publication or any other form
          of abuse of copyrightable materials shall be prohibited without
          referring to initial source. Use of the Trademarks as part of a link
          to or from any site is prohibited unless approved by us in advance.
          All benefits from the use of Trademarks inures to the trademarks’
          owners.
        </Content>
        <Header>Privacy</Header>
        <Content>
          The Website facilitates the privacy of your portfolio information and
          Analysis using a Portfolio Privacy Factor (PPF) that hides your
          portfolio’s inputs (values, asset names and transactions,
          contributions and withdrawals, and management names and fees). This
          factor is calculated outside of the Website, by the user, and is not
          available to the software. If desired, you may enter the portfolio’s
          true inputs and the software calculates and applies the PPF prior to
          importing your portfolio data, thereby maintaining privacy. If
          desired, you may permanently delete any report, prior to storage on
          the Website, after payment and saving to your computer.
        </Content>
        <Header>Compliance with the Law</Header>
        <Content>
          You are solely responsible for ensuring that your use of the Website
          and its Analysis are compliant with the laws of the country and
          jurisdiction of use.
        </Content>
        <Header>Warranty Disclaimer</Header>
        <Content>
          There are no Warranties from the Website, its data, the Analysis, or
          other content, provided to Registered Users or third parties. You
          agree that you use the Website, the Analysis, and content entirely at
          your own risk.
        </Content>
        <Content>
          There is no guarantee that the information contained on the RoboPPA™
          website, its analysis results, and third party publicly available data
          are without error.
        </Content>
        <Content>
          Analysis results from past data are not guaranteed to be applicable in
          the future.
        </Content>
        <Header>Limitation of Liability</Header>
        <Content>
          Your agreement for the use of RoboPPA™ and its use of publicly
          available third-party data provides that RoboPPA™ shall not be liable
          for any loss caused by its historical performance report or for any
          actions taken because of the report.
        </Content>
        <Content>
          RoboPPA™ shall have no liability to any party in connection with Use
          of the Website or its Analysis, by Registered Users for themselves or
          for their clients. Under no circumstances shall RoboPPA™, its
          management, ownership partners, employees, affiliates and/or agents be
          liable for any direct, indirect, incidental, special, punitive,
          exemplary or consequential damages, including lost profits, resulting
          from (a) any aspect of your use of the Website, whether the damages
          result from use or misuse of the Website, from failure to use the
          Website, or the interruption, suspension, modification, alteration, or
          termination of the Website, (b) use of any Analysis or products
          obtained through or advertised in connection with the Website or any
          external links on the Website, (c) use of any information or advice
          obtained through or advertised in connection with the Website or any
          external links on the Website, (d) errors, mistakes, or inaccuracies
          of or in any content, (e) events beyond the reasonable control of
          RoboPPA™. These limitations shall apply to the fullest extent
          permitted by law.
        </Content>
        <Header>Indemnification</Header>
        <Content>
          You agree to defend, indemnify, and hold our management, ownership
          partners, employees, affiliates and/or agents and assigns harmless
          from and against any claims, actions, or demands, including, without
          limitation, reasonable legal and accounting fees, arising or resulting
          from your breach of this Agreement or your access to, use, or misuse
          of the Analysis or Content.
        </Content>
        <Header>Credit Card Transactions </Header>
        <Content>
          All credit card transactions are handled by Stripe, stripe.com. No
          credit card data is stored in any database or storage run by RoboPPA™.
          Any issues with payment must be handled by Stripe. RoboPPA™ claims no
          responsibility for credit card transactions.
        </Content>
      </ContentSection>
      {!isModal && <Footer />}
    </div>
  );
};

export default TermsOfUse;



// WEBPACK FOOTER //
// ./src/home/components/TermsOfUse.js